import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/components/sections/Home/Home';
import FieldClub from '@/components/sections/FieldClub/FieldClub';
import PartySuites from '@/components/sections/PartySuites/PartySuites';
import Suites from '@/components/sections/Suites/Suites';

import PitchViewClub from '@/components/sections/PitchViewClub/Intro';
import PitchViewClubBenefits from '@/components/sections/PitchViewClub/Benefits';
import PitchViewClubSpecs from '@/components/sections/PitchViewClub/Specs';
import PitchViewClubInvestment from '@/components/sections/PitchViewClub/Investment';
import PitchViewClubViews from '@/components/sections/PitchViewClub/Views';


import TunnelClub from '@/components/sections/TunnelClub/Intro';
import TunnelClubBenefits from '@/components/sections/TunnelClub/Benefits';
import TunnelClubSpecs from '@/components/sections/TunnelClub/Specs';
import TunnelClubInvestment from '@/components/sections/TunnelClub/Investment';
import TunnelClubViews from '@/components/sections/TunnelClub/Views';

import CincinnatusClub from '@/components/sections/CincinnatusClub/Intro';
import CincinnatusClubBenefits from '@/components/sections/CincinnatusClub/Benefits';
import CincinnatusClubSpecs from '@/components/sections/CincinnatusClub/Specs';
import CincinnatusClubInvestment from '@/components/sections/CincinnatusClub/Investment';
import CincinnatusClubViews from '@/components/sections/CincinnatusClub/Views';

import FirstFinancialClub from '@/components/sections/FirstFinancialClub/Intro';
import FirstFinancialClubBenefits from '@/components/sections/FirstFinancialClub/Benefits';
import FirstFinancialClubSpecs from '@/components/sections/FirstFinancialClub/Specs';
import FirstFinancialClubInvestment from '@/components/sections/FirstFinancialClub/Investment';
import FirstFinancialClubViews from '@/components/sections/FirstFinancialClub/Views';

import Bailey from '@/components/sections/TheBailey/Intro';
import BaileyBenefits from '@/components/sections/TheBailey/Benefits';
import BaileySpecs from '@/components/sections/TheBailey/Specs';
import BaileyInvestment from '@/components/sections/TheBailey/Investment';
import BaileyViews from '@/components/sections/TheBailey/Views';

import ClubPhilosophy from '@/components/sections/History/ClubPhilosophy';
import ClubRise from '@/components/sections/History/ClubRise';

import Attendance from '@/components/sections/OurFans/Attendance';
import Demographics from '@/components/sections/OurFans/Demographics';
import Cincy from '@/components/sections/OurFans/Cincy';
import Neighbourhood from '@/components/sections/OurFans/Neighbourhood';

import ExteriorLED from '@/components/sections/WestEndStadium/ExteriorLED';
import FoodBeverage from '@/components/sections/WestEndStadium/FoodBeverage';
import LevyCateringGallery from '@/components/sections/LevyCatering/Gallery';
import ByTheNumbers from '@/components/sections/WestEndStadium/ByTheNumbers';

import ReservedSeating from '@/components/sections/ReservedSeating/ReservedSeating';
import ReservedSeatingGallery from '@/components/sections/ReservedSeating/Views';
import ReservedSeatinSpecs from '@/components/sections/ReservedSeating/Specs';
import ReservedSeatinBenefits from '@/components/sections/ReservedSeating/Benefits';
import ReservedSeatinInvestment from '@/components/sections/ReservedSeating/Investment';

import VirtualTour from '@/components/sections/VirtualTour/VirtualTour';

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.NODE_ENV === 'production' ? 'presentation-beta' : '',
  routes: [
    {
      path: '/',
      name: 'Home',
      title: 'Home',
      component: Home,
      index: 1
    },   
    {
      path: '/field-club',
      name: 'Field Club',
      title: 'Field Club',
      component: FieldClub,
    },   
    {
      path: '/party-suites',
      name: 'Party Suites',
      title: 'Party Suites',
      component: PartySuites,
    },   
    {
      path: '/suites-introduction',
      name: 'Suites',
      title: 'Suites',
      component: Suites,
    },
    {
      path: '/pitch-view-club',
      name: 'Pitch View Club',
      title: 'Pitch View Club',
      component: PitchViewClub,
    },   
    {
      path: '/pitch-view-club-benefits',
      name: 'Pitch View Club Benefits',
      title: 'Pitch View Club',
      component: PitchViewClubBenefits,
    },   
    {
      path: '/pitch-view-club-specs',
      name: 'Pitch View Club Specs',
      title: 'Pitch View Club',
      component: PitchViewClubSpecs,
    },   
    {
      path: '/pitch-view-club-investment',
      name: 'Pitch View Club Reserve Yours',
      title: 'Pitch View Club',
      component: PitchViewClubInvestment,
    },   
    {
      path: '/pitch-view-club-views',
      name: 'Pitch View Club Views',
      title: 'Pitch View Club',
      component: PitchViewClubViews,
    },   
    {
      path: '/tunnel-club',
      name: 'Tunnel Club',
      title: 'Tunnel Club',
      component: TunnelClub,
    },
    {
      path: '/tunnel-club-benefits',
      name: 'Tunnel Club Benefits',
      title: 'Tunnel Club',
      component: TunnelClubBenefits,
    },   
    {
      path: '/tunnel-club-specs',
      name: 'Tunnel Club Specs',
      title: 'Tunnel Club',
      component: TunnelClubSpecs,
    },
    {
      path: '/tunnel-club-investment',
      name: 'Tunnel Club Reserve Yours',
      title: 'Tunnel Club',
      component: TunnelClubInvestment,
    },
    {
      path: '/tunnel-club-views',
      name: 'Tunnel Club Views',
      title: 'Tunnel Club',
      component: TunnelClubViews,
    },
    {
      path: '/cincinnatus-club',
      name: 'Cincinnatus Club',
      title: 'Cincinnatus Club',
      component: CincinnatusClub,
    },   
     {
      path: '/cincinnatus-club-benefits',
      name: 'Cincinnatus Club Benefits',
      title: 'Cincinnatus Club',
      component: CincinnatusClubBenefits,
    },   
    {
      path: '/cincinnatus-club-specs',
      name: 'Cincinnatus Club Specs',
      title: 'Cincinnatus Club',
      component: CincinnatusClubSpecs,
    },
    {
      path: '/cincinnatus-club-investment',
      name: 'Cincinnatus Club Reserve Yours',
      title: 'Cincinnatus Club',
      component: CincinnatusClubInvestment,
    },
    {
      path: '/cincinnatus-club-views',
      name: 'Cincinnatus Club Views',
      title: 'Cincinnatus Club',
      component: CincinnatusClubViews,
    },

    {
      path: '/first-financial-club',
      name: 'First Financial Club',
      title: 'First Financial Club',
      component: FirstFinancialClub,
    },   
     {
      path: '/first-financial-club-benefits',
      name: 'First Financial Club Benefits',
      title: 'First Financial Club',
      component: FirstFinancialClubBenefits,
    },   
    {
      path: '/first-financial-club-specs',
      name: 'First Financial Club Specs',
      title: 'First Financial Club',
      component: FirstFinancialClubSpecs,
    },
    {
      path: '/first-financial-club-investment',
      name: 'First Financial Club Reserve Yours',
      title: 'First Financial Club',
      component: FirstFinancialClubInvestment,
    },
    {
      path: '/first-financial-club-views',
      name: 'First Financial Club Views',
      title: 'First Financial Club',
      component: FirstFinancialClubViews,
    },

    {
      path: '/bailey',
      name: 'The Bailey',
      title: 'The Bailey',
      component: Bailey,
    },   
     {
      path: '/bailey-benefits',
      name: 'The Bailet Benefits',
      title: 'The Bailet',
      component: BaileyBenefits,
    },   
    {
      path: '/bailey-specs',
      name: 'The Bailet Specs',
      title: 'The Bailet',
      component: BaileySpecs,
    },
    {
      path: '/bailey-investment',
      name: 'The Bailet Reserve Yours',
      title: 'The Bailet',
      component: BaileyInvestment,
    },
    {
      path: '/bailey-views',
      name: 'The Bailet Views',
      title: 'The Bailet',
      component: BaileyViews,
    },

    {
      path: '/club-philosophy',
      name: 'Club Philosophy',
      title: 'Club Philosophy',
      component: ClubPhilosophy,
    },
    {
      path: '/club-rise',
      name: 'Club Rise',
      title: 'Club Rise',
      component: ClubRise,
    },
    {
      path: "/our-fans",
      name: 'Attendance',
      title: 'Attendance',
      component: Attendance,
    },
    {    
      path: "/demographics",
      name: 'Demographics',
      title: 'Demographics',
      component: Demographics,
    },
    {    
      path: "/neighborhood",
      name: 'Neighborhood',
      title: 'Neighborhood',
      component: Neighbourhood,
    },
    
    {
      path: "/this-is-cincy",
      name: 'This is Cincy',
      title: 'This is Cincy',
      component: Cincy,
    },
    {
      path: "/about-west-end-stadium",
      name: 'Exterior LED',
      title: 'Exterior LED',
      component: ExteriorLED
,
    },
    {
      path: "/by-the-numbers",
      name: 'By the Numbers',
      title: 'By the Numbers',
      component: ByTheNumbers,
    },
    {
      path: "/food-and-beverage",
      name: 'Food & Beverage',
      title: 'Food & Beverage',
      component: FoodBeverage,
    },
    {
      path: "/food-and-beverage-gallery",
      name: 'Food & Beverage Gallery',
      title: 'Food & Beverage Gallery',
      component: LevyCateringGallery,
    },    
    {
      path: "/reserved-seating",
      name: 'Reserved Seating',
      title: 'Reserved Seating',
      component: ReservedSeating,
    },
    {
      path: "/reserved-seating-views",
      name: 'Reserved Seating Views',
      title: 'Reserved Seating Views',
      component: ReservedSeatingGallery,
    },    
    {
      path: "/reserved-seating-specs",
      name: 'Reserved Seating Specs',
      title: 'Reserved Seating Specs',
      component: ReservedSeatinSpecs,
    },    
    {
      path: "/reserved-seating-benefits",
      name: 'Reserved Seating Benefits',
      title: 'Reserved Seating Benefits',
      component: ReservedSeatinBenefits,
    },    
    {
      path: "/reserved-seating-investment",
      name: 'Reserved Seating Investment',
      title: 'Reserved Seating Investment',
      component: ReservedSeatinInvestment,
    },    
    


    {
      path: "/virtual-tour",
      name: 'Virtual Tour',
      title: 'Virtual Tour',
      component: VirtualTour,
    }
  ]
});
